import {Link, useNavigate} from 'react-router-dom';

import {
  Card,
  Container,
  Line,
  LinkText,
  Register,
  Separator,
  SeparatorText,
  Content,
} from './styles';
import Button from 'shared/migration-components/button';
import useProfile from 'modules/users/hooks/use-profile';
import AccessControl from './components/access-control';
import useToken from 'modules/auth/atoms/use-token';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {useQueryClient} from 'react-query';
import logo from 'shared/assets/images/logo.png';
import darkLogo from 'shared/assets/images/logo-dark.png';
import Loading from 'shared/migration-components/loading';
import {useTheme} from 'styled-components';

const AccessControls: React.FC = () => {
  const {data, isLoading} = useProfile();
  const {setToken} = useToken();
  const {setCityId, setCompanyId} = useAccessControls();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const franchise = data?.accessControls.find(
    (accessControl) => accessControl.isFranchiseAccessControl,
  );

  const cities = data?.accessControls.filter(
    (accessControl) =>
      !!accessControl.city && !accessControl.isDeliveryManAccessControl,
  );
  const companies = data?.accessControls.filter(
    (accessControl) => !!accessControl.company,
  );

  const {colors} = useTheme();

  const theme = localStorage.getItem('theme');

  return (
    <Container>
      <Content>
        <Card>
          <img
            src={theme === 'dark' ? darkLogo : logo}
            style={{
              width: 180,
              height: 120,
              alignSelf: 'center',
              marginLeft: -20,
            }}
          />
          {franchise && <AccessControl {...franchise} />}
          {!isLoading && cities?.length > 0 && (
            <div>
              <p style={{marginBottom: 8, color: colors.text}}>Cidades</p>
              <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                {cities?.map((accessControl) => (
                  <AccessControl key={accessControl.id} {...accessControl} />
                ))}
              </div>
            </div>
          )}
          {!isLoading && companies?.length > 0 && (
            <div>
              <p style={{marginBottom: 8, color: colors.text}}>Empresas</p>
              <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                {companies?.map((accessControl) => (
                  <AccessControl key={accessControl.id} {...accessControl} />
                ))}
              </div>
            </div>
          )}
          {isLoading && <Loading />}
          {(companies?.length || cities?.length || franchise) && (
            <Separator>
              <Line />
              <SeparatorText>OU</SeparatorText>
              <Line />
            </Separator>
          )}
          <Button
            onClick={() => navigate('/create-company')}
            title="Criar nova loja"
            widthMode="expand"
          />
        </Card>
        <Register
          onClick={() => {
            setToken(null);
            queryClient.clear();
            setCityId(null);
            setCompanyId(null);
          }}>
          Trocar de conta?
          <Link to="/login">
            <LinkText> Sair</LinkText>
          </Link>
        </Register>
      </Content>
    </Container>
  );
};

export default AccessControls;
